import { Box, Button, TextField } from '@mui/material';
import moment, { DurationInputArg1, DurationInputArg2 } from 'moment';
import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Fragment } from 'react/jsx-runtime';
import {
    sendShareCodeMailStart,
    shareScene3dStart,
} from '../../../store/attachment/attachment.action';
import { setIsError } from '../../../store/error/error.action';
import {
    FlexBoxFullW,
    FlexBoxFullWHColumn,
    FlexBoxFullWRowBetween,
} from '../../layout/layout.styles';
import DialogContent from '../../ui/dialog-content/dialog-content.component';
import DialogTitle from '../../ui/dialog-title/dialog-title.component';
import {
    ShareDateBox,
    ShareDateLabel,
    ShareDatePicker,
} from './dialog-share-scene-3d.styles';
const DialogShareScene3d = ({ inputData }: { inputData: any }) => {
    const [dateSelected, setDateSelected] = useState<Date>(new Date());
    const [qrCode, setQrCode] = useState<string>();
    const [url, setUrl] = useState<string>();
    const [code, setCode] = useState<string>();

    const emailInput = useRef<HTMLInputElement>(null);

    const dispatch = useDispatch();

    const handleRangeButtonClick = (
        value: DurationInputArg1,
        unit: DurationInputArg2
    ) => {
        setDateSelected(moment(new Date()).add(value, unit).toDate());
    };

    const handleConfirmShareButtonClick = () => {
        const validUntil = moment(dateSelected).utc().format('YYYY-MM-DD');
        dispatch(
            shareScene3dStart(inputData.sceneId, validUntil, (resp) => {
                setQrCode(resp.svg);
                setUrl(resp.url);
                setCode(resp.code);
            })
        );
    };

    const handleDownloadButtonClick = () => {
        const link = document.createElement('a');
        link.download = 'qr-code-scena-3d.svg';
        link.href =
            'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(qrCode!);
        link.click();
    };

    const handleCopyUrlClick = () => {
        navigator.clipboard.writeText(url!);
    };

    const handleSendEmailButtonClick = () => {
        if (code && emailInput.current?.value) {
            dispatch(
                sendShareCodeMailStart(code, emailInput.current.value, () => {
                    emailInput.current!.value = '';
                })
            );
        } else {
            dispatch(setIsError(true, 'Inserisci email'));
        }
    };

    return (
        <Fragment>
            <DialogTitle title="Condividi Scena 3D" />
            <DialogContent height={qrCode ? 'auto' : '100vh'}>
                {qrCode && code ? (
                    <FlexBoxFullWHColumn justifyContent={'center'}>
                        <ShareDateLabel textAlign={'center'}>
                            QRCode generato con successo!
                        </ShareDateLabel>
                        <Box my={1} />
                        <FlexBoxFullW
                            sx={{
                                '& svg': {
                                    backgroundColor: 'white',
                                },
                            }}
                            justifyContent={'center'}
                            alignItems={'center'}
                            dangerouslySetInnerHTML={{ __html: qrCode }}
                        />
                        <Box my={1} />
                        <Button
                            variant="contained"
                            fullWidth
                            sx={{
                                borderRadius: '15px',
                                color: 'info.main',
                                fontWeight: 'bold',
                                alignSelf: 'center',
                                lineHeight: '1.5',
                            }}
                            onClick={handleDownloadButtonClick}
                        >
                            SCARICA
                        </Button>
                        <Box my={1} />
                        <Button
                            fullWidth
                            variant="contained"
                            sx={{
                                borderRadius: '15px',
                                color: 'info.main',
                                fontWeight: 'bold',
                                alignSelf: 'center',
                                lineHeight: '1.5',
                            }}
                            onClick={handleCopyUrlClick}
                        >
                            COPIA URL NEGLI APPUNTI
                        </Button>
                        <Box my={2} />
                        <TextField
                            label="Email Destinatario"
                            inputRef={emailInput}
                        />
                        <Box my={1} />
                        <Button
                            variant="contained"
                            fullWidth
                            sx={{
                                borderRadius: '15px',
                                color: 'info.main',
                                fontWeight: 'bold',
                                alignSelf: 'center',
                                lineHeight: '1.5',
                            }}
                            onClick={handleSendEmailButtonClick}
                        >
                            INVIA URL PER EMAIL
                        </Button>
                    </FlexBoxFullWHColumn>
                ) : (
                    <FlexBoxFullWHColumn>
                        <ShareDateLabel>
                            SELEZIONA DATA DI SCADENZA
                        </ShareDateLabel>
                        <Box py={1} />
                        <ShareDateBox p={2}>
                            <FlexBoxFullWRowBetween
                                justifyContent={'center'}
                                gap={2}
                            >
                                <Button
                                    variant="contained"
                                    sx={{
                                        borderRadius: '15px',
                                        color: 'info.main',
                                        fontWeight: 'bold',
                                        width: '100% !important',
                                        alignSelf: 'end',
                                        lineHeight: '1.5',
                                    }}
                                    onClick={() =>
                                        handleRangeButtonClick(3, 'day')
                                    }
                                >
                                    3 GIORNI
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        borderRadius: '15px',
                                        color: 'info.main',
                                        fontWeight: 'bold',
                                        width: '100% !important',
                                        alignSelf: 'end',
                                        lineHeight: '1.5',
                                    }}
                                    onClick={() =>
                                        handleRangeButtonClick(1, 'week')
                                    }
                                >
                                    1 SETTIMANA
                                </Button>
                            </FlexBoxFullWRowBetween>
                            <Box my={1} />
                            <FlexBoxFullWRowBetween
                                justifyContent={'center'}
                                gap={2}
                            >
                                <Button
                                    variant="contained"
                                    sx={{
                                        borderRadius: '15px',
                                        color: 'info.main',
                                        fontWeight: 'bold',
                                        width: '100% !important',
                                        alignSelf: 'end',
                                        lineHeight: '1.5',
                                    }}
                                    onClick={() => {
                                        handleRangeButtonClick(1, 'month');
                                    }}
                                >
                                    1 MESE
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        borderRadius: '15px',
                                        color: 'info.main',
                                        fontWeight: 'bold',
                                        width: '100% !important',
                                        alignSelf: 'end',
                                        lineHeight: '1.5',
                                    }}
                                    onClick={() => {
                                        handleRangeButtonClick(3, 'month');
                                    }}
                                >
                                    3 MESI
                                </Button>
                            </FlexBoxFullWRowBetween>
                            <Box my={1} />
                            <ShareDatePicker
                                slotProps={{
                                    toolbar: {
                                        toolbarFormat: 'DD MMMM YYYY',
                                        hidden: false,
                                    },
                                }}
                                localeText={{
                                    toolbarTitle: 'Data validità fino al',
                                }}
                                disablePast
                                value={moment(dateSelected)}
                                onChange={(date) =>
                                    setDateSelected(date!.toDate())
                                }
                            />
                        </ShareDateBox>
                        <Box my={1} />
                        <Button
                            variant="contained"
                            sx={{
                                borderRadius: '15px',
                                color: 'info.main',
                                fontWeight: 'bold',
                                width: '206px !important',
                                alignSelf: 'end',
                                lineHeight: '1.5',
                            }}
                            onClick={handleConfirmShareButtonClick}
                        >
                            CONFERMA
                        </Button>
                    </FlexBoxFullWHColumn>
                )}
            </DialogContent>
        </Fragment>
    );
};

export default DialogShareScene3d;
